module.exports = __webpack_public_path__ + "img/meditur-catania.ce11588f.jpg";